import axios from "axios";
import { ISRB } from "../models/srb";

export const createNewSRB = async (srb: ISRB) => {
    const res = await axios.post("/api/servicerecordbook", srb);
    return res.data as ISRB;
};

export const editSRB = async (srb: ISRB) => {
    return axios.patch("/api/servicerecordbook/" + srb.guid, srb);
};

export const downloadSRB = async (guid: string, isCombined: boolean, filename: string) => {
    const res = await axios.get(`/api/servicerecordbook/${guid}/download`, {
        params: { isCombined: isCombined },
        responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};
